import { gql } from '@apollo/client'

export const CREATE_WORK_ORDER = gql`
  mutation CreateWorkOrderService($payload: CreateWorkOrderServiceInput) {
    createWorkOrderService(payload: $payload)
  }
`
